// extracted by mini-css-extract-plugin
export default {"wrapper":"Panel_wrapper__+zpRl"};